export function delay(time) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, time)
  })
}

export function debug(value) {
  const isDebug = true
  if (isDebug) console.log(value)
}